export enum AgreementTypeVo {
  /** 카카오 서비스 약관 */
  KakaoTerm = 'A',
  /** 무료이용권 및 캐시선물 수신 알림 */
  FreeTicketCashPresentNoti = 'B',
  /** 카카오페이지 카톡 채널 추가 */
  Friends = 'C',
  /** 개인 정보 수집 및 이용 */
  Privacy = 'D',
  /** 야간 선물 수신 알림 */
  NightMarketing = 'E',
  Marketing = 'F',
  /** 카카오페이지 유료서비스 이용 */
  TermsPaid = 'G',
  /** 카카오페이지 개인정보 제3자 제공 */
  PersonalInformationThird = 'H',
  /** 카카오페이지 개인정보 수집 및 이용 */
  PersonalInformation = 'L',

  /** 14세 미만 보호자 인증 약관 리스트 */
  ParentPrivacy = 'M',
  ChildPrivacy = 'N',
  ChildPersonalInformationThird = 'O',
  ChildMarketingThird = 'P',

  Under14 = 'K',
  /** 14세 이상 */
  Over14 = 'J',
  /** 실제 약관 타입은 아닙니다. Enum 타입의 기본값 처리를 위해 추가했습니다. */
  None = 'None',
}
